import FormationLayout from "./FormationLayout";
import { AlertBox } from "@/components/Shared";

export default function FormationHygiene() {
  return (
    <FormationLayout
      seoTitle="Formation Hygiène alimentaire & Plan de Maîtrise Sanitaire — Form Action Pro"
      seoDesc="Action de perfectionnement en hygiène alimentaire : bonnes pratiques, Plan de Maîtrise Sanitaire, préparation aux contrôles. Durée 1 à 3 jours, sur devis."
      path="/formations/hygiene-pms"
      kicker="Formation"
      title="Hygiène alimentaire & Plan de Maîtrise Sanitaire"
      subtitle="Perfectionner les pratiques d’hygiène de vos équipes et structurer le Plan de Maîtrise Sanitaire de votre établissement, avec un formateur issu de la restauration."
      dureeBadge="1 à 3 jours"
      publicCible="Professionnels de la restauration commerciale et collective"
      alert={
        <AlertBox title="Action de perfectionnement — information réglementaire importante">
          <p>
            Cette formation est une <strong>action de perfectionnement professionnel</strong>. Il ne
            s’agit <strong>pas</strong> de la formation réglementaire de 14 heures prévue à
            l’article L.233-4 du code rural et de la pêche maritime, réservée depuis le 1er février
            2026 aux organismes autorisés par la DRAAF.
          </p>
          <p>
            Dossier d’autorisation déposé auprès de la DRAAF en mai 2026, recevable, en attente de
            la certification qualité ; objectif : autorisation et référencement ROFHYA fin 2026.
          </p>
        </AlertBox>
      }
      objectifs={[
        "Rappeler les obligations réglementaires de l’exploitant en matière d’hygiène alimentaire.",
        "Mettre en œuvre les bonnes pratiques d’hygiène au quotidien, en cuisine comme en salle.",
        "Construire, tenir à jour et faire vivre le Plan de Maîtrise Sanitaire de l’établissement.",
        "Préparer sereinement l’établissement aux contrôles officiels.",
      ]}
      programme={[
        {
          titre: "Cadre réglementaire",
          texte:
            "Paquet Hygiène, obligations de l’exploitant, déroulement d’un contrôle officiel, sanctions possibles. Savoir exactement ce que l’administration attend de vous.",
        },
        {
          titre: "Bonnes pratiques d’hygiène",
          texte:
            "Personnel, locaux, matériel, denrées : températures, chaîne du froid, contaminations croisées, DLC et étiquetage. Les gestes qui sécurisent, au quotidien.",
        },
        {
          titre: "Le Plan de Maîtrise Sanitaire",
          texte:
            "Construction du PMS : documents, traçabilité, plans de nettoyage et de désinfection, relevés de températures. Un plan simple, tenu, et défendable en contrôle.",
        },
        {
          titre: "Faire vivre le PMS",
          texte:
            "Contrôles internes, gestion des non-conformités, formation et implication des équipes, audit interne. Parce qu’un PMS qui dort dans un tiroir ne protège personne.",
        },
      ]}
      duree="1 à 3 jours"
      prerequis="exercer ou envisager d’exercer une activité en restauration commerciale ou collective."
    />
  );
}
